<div class="privacy-concerns" *ngIf="display">
  <div class="privacy-concerns-text">
    <span class="me-2">
      <strong i18n>Friendly Reminder:</strong>&#32;
      <ng-container i18n>
        the sharing system used for this video implies that some technical information about your system (such as a public IP address) can be sent to other peers.
      </ng-container>
    </span>

    <a i18n i18n-title title="Get more information" target="_blank" rel="noopener noreferrer" href="/about/peertube#privacy">More information</a>
  </div>

  <button i18n class="ms-2 peertube-button orange-button" (click)="acceptedPrivacyConcern()">
    OK
  </button>
</div>
